//  campaign level styles
export const missingFieldsStyle = {
    boxSizing: 'border-box',
    height: 44,
    width: 467,
    border: '1px solid #436F04',
    borderRadius: 6,
    backgroundColor: '#E9FDCC',
    color: '#000000',
    fontFamily: 'Roboto',
    fontSize: 14,
    fontWeight: 500,
    paddingTop: 12
};

export const cancelMessageButtonStyle = {
    width: 87,
    border: '2px solid #CCCCCC',
    backgroundColor: '#FFFFFF',
    cursor: 'pointer'
};

export const okMessageButtonStyle = {
    height: 36,
    width: 130,
    border: '2px solid #FD9A00',
    backgroundColor: '#FAA800',
    cursor: 'pointer'
};

export const runningCampaignStyle = {
    border: '5px solid #C40606',
};

export const pageContainerStyle = {
    margin: '20px 40px',
    width: 'calc(100vw - 80px)' // 80px = total horizontal margin
};

export const sectionedPanelStyle = {
    boxSizing: 'border-box',
    border: '1px solid #D7D7D7',
    borderRadius: 8,
    backgroundColor: '#FFFFFF'
};

export const gridContainerStyle = {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    gridTemplateRows: '60px 57px 1fr',
    gridGap: 0,
    height: '97%'
};

export const gridItemStyle = {
    textAlign: 'center',
    padding: 0
};

export const iconPlusMinimiseStyle = {
    verticalAlign: 'bottom',
    marginLeft: 8,
    marginTop: 2,
    cursor: 'pointer'
};
